import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const CalendarOutlineIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 70 80" {...props}>
      <path
        fill={fill}
        d="M53.4879032,71.8322222 L16.5132258,71.8322222 C11.9609677,71.8322222 8.2566129,68.1688889 8.2566129,63.6655556 L8.2566129,37.1988889 L61.7445161,37.1988889 L61.7445161,63.6655556 C61.7445161,68.1688889 58.0401613,71.8322222 53.4879032,71.8322222 M54.2624194,10.7955556 L54.2624194,5.10444444 C54.2624194,2.29666667 51.938871,0 49.1016129,0 C46.2632258,0 43.9408065,2.29666667 43.9408065,5.10444444 L43.9408065,10.7577778 L26.0614516,10.7577778 L26.0614516,5.10444444 C26.0614516,2.29666667 23.7379032,0 20.9006452,0 C18.0622581,0 15.7398387,2.29666667 15.7398387,5.10444444 L15.7398387,10.7955556 C6.99548387,11.2 0,18.3433333 0,27.0911111 L0,63.6655556 C0,72.6722222 7.40870968,80 16.5132258,80 L53.4879032,80 C62.5924194,80 70,72.6722222 70,63.6655556 L70,27.0911111 C70,18.3433333 63.0067742,11.2 54.2624194,10.7955556"
      />
    </Icon>
  );
};

CalendarOutlineIcon.propTypes = {
  fill: PropTypes.string,
};

export default CalendarOutlineIcon;
